class ShortcutButtonDirective {
    constructor(ShortcutService) {
        'ngInject';

        this.scope = {
            shortcutKey: '@'
        };
        this.ShortcutService = ShortcutService;
    }

    link(scope, element,attrs) {

        let shortcut = {
            altKey: attrs.shortcutAlt !== undefined,
            ctrlKey: attrs.shortcutCtrl !== undefined,
            key: scope.shortcutKey,
            validate: () => true,
            handle: () => element.click()
        }

        this.ShortcutService.registerShortcut(shortcut)
        element.on('$destroy', () => this.ShortcutService.unregisterShortcut(shortcut));
    }
}


(function () {
    'use strict';
    angular.module('doclr.components.util')
        .directive('shortcutButton', (ShortcutService) => new ShortcutButtonDirective(ShortcutService));
})();